import React from "react";
import classNames from "classnames";
import { Transition } from "react-transition-group";

import "./styles.styl";

export default function Overlay(props) {
  const { active, className, onClick, children, isRegistration } = props;

  return (
    <Transition in={active} timeout={400}>
      {(state) => (
        <div
          className={classNames(
            "overlay",
            { "is-active": active },
            "is-" + state,
            className,
          )}
          onClick={onClick}
        >
          <div
            className={classNames("overlay__inner", {
              "is-register": isRegistration,
            })}
          >
            {state !== "exited" && children}
          </div>
        </div>
      )}
    </Transition>
  );
}
